export default __webpack_public_path__ + "static/media/services_react_development.feaf29d5.png";